import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

    authenticatedContext: null

  },
  mutations: {

    setUser: function(state, context) {

      state.authenticatedContext = context;

    }

  },
  actions: {

  }

})
